import { Component } from '@theme/component';

/**
 * 表示形式（カード／リスト）と表示件数（24／48）の切替（#372）。
 *
 * Liquid は `request` からクエリパラメータを読めないので、状態は `?view=` の代替テンプレートで持つ。
 * マークアップ側の href には view だけを載せてあるため（JS 無効時の最低限の動作）、ここで
 * 現在の絞り込み・並び替えを引き継いだ URL に差し替えてから遷移する。
 *
 * Section Rendering API は `view` を無視する（`section_id` がテンプレートを決め、他テンプレートの
 * section_id は Liquid から取れない）ので、部分更新ではなくページ遷移にしている。
 */
class ViewControlsYokomo extends Component {
  /**
   * 押された要素の view 値で現在の URL を組み替えて遷移する。
   *
   * @param {Event} event
   */
  navigate(event) {
    const { target } = event;
    if (!(target instanceof Element)) return;

    const source = target.closest('select, [data-view]');
    if (!source) return;

    const view = source instanceof HTMLSelectElement ? source.value : (source.getAttribute('data-view') ?? '');

    // href の既定動作だと絞り込みが落ちるので、こちらで組み替える
    event.preventDefault();

    const url = new URL(window.location.href);

    if (view) {
      url.searchParams.set('view', view);
    } else {
      url.searchParams.delete('view');
    }

    // 1ページあたりの件数が変わると「何ページ目か」の意味も変わるので先頭へ戻す
    url.searchParams.delete('page');

    window.location.assign(url.toString());
  }
}

if (!customElements.get('view-controls-yokomo')) {
  customElements.define('view-controls-yokomo', ViewControlsYokomo);
}
